var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffectiveStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.916,
    height: 13.235,
    viewBox: "0 0 13.916 13.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14122",
    "data-name": "Path 14122",
    d: "M6.958,0,4.806,4.357,0,5.057,3.476,8.448l-.818,4.786,4.3-2.259,4.3,2.259-.821-4.786,3.479-3.391-4.808-.7Z",
    transform: "translate(0)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffectiveStar);
export default __webpack_public_path__ + "static/media/effective-star.f296afb6bdfa4e9567d3a345923729c4.svg";
export { ForwardRef as ReactComponent };